export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9009.9f0c2bf9.jpg";